import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)
const isDark = localStorage.getItem('blueberry_dark-theme') == 'true' ? true : false;

const opts = {
    theme: {
        dark: isDark
    }
}

export default new Vuetify(opts)